import { CalendarSurfaceCalendarsStore } from './schema/CalendarSurfaceCalendarsStore';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import { CalendarEventsLoadingState } from 'owa-calendar-events-store';

let calendarStoreData: CalendarSurfaceCalendarsStore = {
    calendars: [],
    selectedCalendars: [],
    localLieCalendarIds: new ObservableMap<string, true>(),
    calendarLoadingState: new ObservableMap<string, CalendarEventsLoadingState>({}),
    calendarGroups: [],
};

export let getStore = createStore<CalendarSurfaceCalendarsStore>(
    'calendarSurfaceCalendarsStore',
    calendarStoreData
);
let store = getStore();

export default store;
